import { t } from '@/i18n';
import { DateRangeSchema } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const workflowStatus = z.enum(['all', 'unapproved', 'approved']);
const _WorkflowStatusLabelModifier = {
  all: t('all'),
  unapproved: t('workflow.status-unapproved'),
  approved: t('workflow.status-approved'),
} as const satisfies Record<z.infer<typeof workflowStatus>, string>;

const actionRequiredEnum = z.enum([
  'all',
  'action-required',
  'no-action-required',
]);
const _ActionRequiredLabelModifier = {
  all: t('all'),
  'action-required': t('workflow.action-required'),
  'no-action-required': t('workflow.no-action-required'),
} as const satisfies Record<z.infer<typeof actionRequiredEnum>, string>;

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const WorkflowSearchFormSchema = z.object({
  createdMonthRange: DateRangeSchema.nullable(),
  actionRequired: actionRequiredEnum,
  keyword: z.string().nullable(),
  stageLabelId: z.string().uuid().nullable(),
  tagIds: z.string().uuid().array(),
  workflowStatus: workflowStatus,
});
